import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitorPlay, LayoutDashboard, ArrowRight, BrainCircuit } from 'lucide-react';

const WelcomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6">
      <div className="mb-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-12 w-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/30">
                <BrainCircuit className="text-white" size={32} />
            </div>
            <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">AiLabQuant</h1>
        </div>
        <p className="text-slate-500 text-lg">Select your workspace to begin</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
        
        {/* OPTION 1: RETAIL / INVEST */}
        <div 
            onClick={() => navigate('/dashboard')}
            className="group bg-white p-8 rounded-2xl shadow-sm border-2 border-slate-100 hover:border-blue-500 hover:shadow-xl transition-all cursor-pointer relative overflow-hidden"
        >
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <LayoutDashboard size={120} />
            </div>
            <div className="relative z-10">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-6">
                    <LayoutDashboard size={24} />
                </div>
                <h2 className="text-2xl font-bold text-slate-800 mb-2">AiQ Invest</h2>
                <p className="text-slate-500 mb-6">
                    Personal portfolio management, news intelligence, and community discussions.
                </p>
                <span className="text-blue-600 font-bold flex items-center gap-2 group-hover:gap-4 transition-all">
                    Launch Workspace <ArrowRight size={18} />
                </span>
            </div>
        </div>

        {/* OPTION 2: PRO TERMINAL */}
        <div 
            onClick={() => navigate('/aiq')}
            className="group bg-[#0B1120] p-8 rounded-2xl shadow-2xl hover:scale-[1.02] transition-all cursor-pointer relative overflow-hidden ring-1 ring-white/10"
        >
             <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity text-blue-500">
                <MonitorPlay size={120} />
            </div>
            <div className="relative z-10">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-6 shadow-lg shadow-blue-500/40">
                    <MonitorPlay size={24} />
                </div>
                <h2 className="text-2xl font-bold text-white mb-2">AiQ Terminal <span className="text-xs bg-blue-600 px-2 py-0.5 rounded ml-2 uppercase tracking-wide">Pro</span></h2>
                <p className="text-slate-400 mb-6">
                    Institutional-grade execution, risk management, and quantitative pricing engine.
                </p>
                <span className="text-white font-bold flex items-center gap-2 group-hover:gap-4 transition-all">
                    Initialize Terminal <ArrowRight size={18} />
                </span>
            </div>
        </div>

      </div>
      
      <p className="mt-12 text-slate-400 text-sm">
        Signed in as <span className="font-semibold text-slate-600">Guest User</span> • <span className="hover:underline cursor-pointer">Switch Account</span>
      </p>
    </div>
  );
};

export default WelcomePage;